/**
 * Ensures the input is an array
 * @param v - Value that may or may not be an array
 * @returns Array containing the value(s)
 */
const ensureArray = <T>(v: T | T[]): T[] => (Array.isArray(v) ? v : [v]);

export default ensureArray;
